wbApp.factory('contentSvc', ['$resource', 'repositorySvc',
    function ($resource, repositorySvc) {
        var Content = $resource('/restapi/html-content', {}, {
            'get': { method: 'GET', isArray: false, url: '/restapi/html-content/:id' },
            'update': { method: 'PUT', url: '/restapi/html-content/:id' },
            'delete': { method: 'DELETE', url: '/restapi/html-content/:id' },
        });

        function getById(id) {
            return Content['get']({ id: id });
        }

        function update(model) {
            return repositorySvc.customPutWithParams(
                'update',
                Content,
                { id: model.id },
                model);
        }

        function remove(id) {
            return repositorySvc.customDelete(
                'delete',
                Content,
                { id: id });
        }

        return {
            getById: getById,
            update: update,
            remove: remove
        }
    }]);